import { DatePicker as ArkUiDatePicker, parseDate } from "@ark-ui/react";

export interface DatePickerRootProps
  extends Omit<ArkUiDatePicker.RootProps, "min" | "max"> {
  min?: string;
  max?: string;
  locale: NonNullable<ArkUiDatePicker.RootProps["locale"]>;
}

export default function Root({
  open = true,
  // Switching min & max from a string to undefined & vise versa is not working
  min = "1900-01-01",
  max = "2100-01-01",
  ...props
}: DatePickerRootProps) {
  return (
    <ArkUiDatePicker.Root
      {...props}
      open={open}
      min={parseDate(min)}
      max={parseDate(max)}
    />
  );
}
